import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { EMediaBreakpoint } from "shared/enum/media/media-breakpoint.enum";

@Injectable({
  providedIn: 'root'
})
export abstract class IMediaService {

  public abstract mediaUpdate(width: number): void;

  public abstract mediaBreakpointGet(): EMediaBreakpoint;

  public abstract mediaBreakpointChangeGet(): Observable<EMediaBreakpoint>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IMediaServiceToken = new InjectionToken<IMediaService>('IMediaService');
